import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      nav("/admin");
    } catch (e) {
      const d = e?.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="admin-login">
      <form
        onSubmit={submit}
        className="w-full max-w-md border border-charcoal/25 bg-bone p-10"
      >
        <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-stone-muted">Bosecrafts · Admin</p>
        <h1 className="mt-4 font-display text-4xl tracking-tightest">Sign in.</h1>

        <label className="block mt-10">
          <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-stone-muted">Email</span>
          <input
            data-testid="admin-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-2 w-full bg-transparent border-b border-charcoal/40 focus:border-charcoal outline-none py-2 font-serif"
            autoComplete="email"
          />
        </label>
        <label className="block mt-8">
          <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-stone-muted">Password</span>
          <input
            data-testid="admin-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-2 w-full bg-transparent border-b border-charcoal/40 focus:border-charcoal outline-none py-2 font-serif"
            autoComplete="current-password"
          />
        </label>

        {err && (
          <p className="mt-6 text-sm text-destructive" data-testid="admin-error">
            {err}
          </p>
        )}

        <button
          type="submit"
          disabled={busy}
          data-testid="admin-submit"
          className="mt-10 w-full border border-charcoal bg-charcoal text-ivory disabled:bg-stone-soft py-3 text-[11px] uppercase tracking-[0.22em] hover:bg-ivory hover:text-charcoal transition-colors"
        >
          {busy ? "Signing in…" : "Sign in →"}
        </button>
      </form>
    </div>
  );
}
